import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/app/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 rounded ",
  {
    variants: {
        block: {
            true: "w-full",
        },
      variant: {
        default:
          "bg-orange-600 shadow hover:bg-orange-700 text-white",
        destructive:
          "bg-red-500 shadow-sm hover:bg-destructive/90 text-white",
        outline:
          "border border-input bg-background shadow-sm hover:text-orange-600 text-gray-700",
        secondary:
          "bg-secondary shadow-sm hover:bg-secondary/80",
        ghost: "text-gray-700 hover:text-orange-600",
        link: "text-orange-600 underline-offset-4 hover:underline",
        active: "bg-orange-500 text-white",
        inactive: "bg-gray-500 text-white",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-10 px-8",
        icon: "h-9 w-9",    
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
    asChild?: boolean;
    block?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, block = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className, block }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants }; 